<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDoubleChevronRight_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M17.726 11.203 13.05 6.528a.934.934 0 1 0-1.322 1.322l4.014 4.014-4.014 4.014A.934.934 0 1 0 13.05 17.2l4.675-4.675a.934.934 0 0 0 0-1.322m-5.454-.156L7.597 6.37a.934.934 0 1 0-1.322 1.322l4.014 4.015-4.014 4.014a.934.934 0 1 0 1.322 1.322l4.675-4.675a.934.934 0 0 0 0-1.322"
        clip-rule="evenodd"
    />
</svg>
